import { NAV_LINKS } from "@/config/site";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="py-12 px-6 border-t border-stone-900 bg-black text-stone-400 text-xs"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="space-y-1 text-center md:text-left">
          <div className="text-stone-300 font-bold text-sm uppercase">
            The Bourganization Institute (BGNZN)
          </div>
          <div>501(c)(6) Non-Profit Business League · Autonomous Tax Haven BGNZN</div>
          <div>BOURG MERCHANT EXCHANGE (BMEX) · 501(c)(2) Privatized Non-Marketable Exchange</div>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-6">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`footer-${link.testid}`}
              className="hover:text-amber-400 transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="/portal"
            data-testid="footer-registry-link"
            className="text-stone-600 hover:text-amber-400 transition-colors mono-tag text-[10px] uppercase tracking-widest"
          >
            Registry
          </a>
          <a
            href="/wallet"
            data-testid="footer-wallet-link"
            className="text-amber-500/80 hover:text-amber-400 transition-colors mono-tag text-[10px] uppercase tracking-widest"
          >
            Member Wallet
          </a>
          <a
            href="/register"
            data-testid="footer-register-link"
            className="text-stone-600 hover:text-amber-400 transition-colors mono-tag text-[10px] uppercase tracking-widest"
          >
            Merchant Register
          </a>
          <a
            href="/sms-program"
            data-testid="footer-sms-program-link"
            className="text-stone-600 hover:text-amber-400 transition-colors mono-tag text-[10px] uppercase tracking-widest"
          >
            SMS Program
          </a>
          <a
            href="/privacy"
            data-testid="footer-privacy-link"
            className="text-stone-600 hover:text-amber-400 transition-colors mono-tag text-[10px] uppercase tracking-widest"
          >
            Privacy
          </a>
          <a
            href="/terms"
            data-testid="footer-terms-link"
            className="text-stone-600 hover:text-amber-400 transition-colors mono-tag text-[10px] uppercase tracking-widest"
          >
            Terms
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
